import {Error, ValidationResult, Validator} from '@/type/validation/result';

import {年月書式, 必須入力} from '@/type/validation/validator';
import {薬品受払表出力依頼型} from '@/type/custom/goryoukaku/薬品受払表出力依頼型';


export default class 薬品受払表出力依頼チェッカー {
  単項目チェック結果: Error[];

  constructor(target: 薬品受払表出力依頼型) {
    const 単項目チェック = new ValidationResult(単項目チェックvalidators);
    単項目チェック.validate(target);
    this.単項目チェック結果 = 単項目チェック.getErrors;
  }

  hasErrors(): boolean {
    return this.単項目チェック結果.length > 0;
  }

  hasError(name: string): boolean {
    return this.単項目チェック結果.some((error) => (error.name === name && error.index === 0));
  }

  errorMessages(): string[] {
    return this.単項目チェック結果
      .map((value) => `${value.message}`);
  }
}

const 単項目チェックvalidators: Validator[] = [
  {
    name: '受払対象年月FROM',
    constraints: [
      {method: 必須入力, message: '対象年月FROMは入力必須項目です'},
      {method: 年月書式, message: '対象年月FROMの書式が不正です'},
    ],
  },
  {
    name: '受払対象年月TO',
    constraints: [
      {method: 必須入力, message: '対象年月TOは入力必須項目です'},
      {method: 年月書式, message: '対象年月TOの書式が不正です'},
    ],
  },
  {
    name: '出力コード区分',
    constraints: [
      {method: 必須入力, message: '出力コードは入力必須項目です'},
    ],
  },
];

